const contentTab = document.querySelectorAll(".collapsible-content");
const dataTab = document.querySelector(".js-tab-item.active").getAttribute("data-country");
const tabList = document.querySelectorAll(".js-tab-item");

if (contentTab) {
  contentTab.forEach(item => {
    if (dataTab == item.getAttribute("data-tab")) {
      item.classList.add('active')
    } else {
      item.classList.add('hide')
    }
  })
}

tabList.forEach(item => {
  item.addEventListener("click", (e) => {
    tabList.forEach(item => {
      item.classList.remove('active');
    })
    item.classList.add('active');
    const dataTab = document.querySelector(".js-tab-item.active").getAttribute("data-country");
    if (contentTab) {
      contentTab.forEach(item => {
        if (dataTab == item.getAttribute("data-tab")) {
          item.classList.add('active');
          item.classList.remove('hide');
        } else {
          item.classList.add('hide');
          item.classList.remove('active')
        }
      })
    }
  })
})